import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { EntityService } from '../../entity.service';

@Component({
    selector: 'app-timings',
    templateUrl: './timings.component.html',
    styleUrls: ['./timings.component.scss'],
})
export class TimingsComponent implements OnInit {
    dialogRef: any;
    configForm: FormGroup;
    timings;
    shwErr = false;
    showDta = true;
    showEdt = false;
    shw24Hrs = false;
    editInputData;
    @Input() timngsInput;
    timingColumns = [];
    constructor(
        private _entityService: EntityService,
        private _matDialog: MatDialog,
        private _fuseConfirmationService: FuseConfirmationService,
        private _formBuilder: FormBuilder,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        this.configForm = this._formBuilder.group({
            title: 'Are you sure want to delete',
            message: 'You will loose the timings added to the list',
            icon: this._formBuilder.group({
                show: true,
                name: 'heroicons_outline:exclamation',
                color: 'warn',
            }),
            actions: this._formBuilder.group({
                confirm: this._formBuilder.group({
                    show: true,
                    label: 'Yes',
                    color: 'primary',
                }),
                cancel: this._formBuilder.group({
                    show: true,
                    label: 'No',
                }),
            }),
            dismissible: true,
        });
    }

    ngOnInit(): void {
        console.log('Start Timing Input', this.timngsInput);
        // if(this.closeOtpt){
        //   if(this.closeOtpt.val == 'close'){
        //     this.showDta = true;
        //     this.showEdt = false;
        //   }
        // }
        this.getTmng(this.timngsInput.enty_ky, 'facility');
    }

    // addTmng() {
    //   const dialogRef = this._matDialog.open(AddTimingComponent, {
    //     data: {
    //       hndlr_nm: 'facility',
    //       enty_ky: this.fcltyLst[0].fclty_id,
    //       val: 'add'
    //     }
    //   });

    //   dialogRef.afterClosed()
    //     .subscribe((result) => {
    //       this.getTmng(this.fcltyLst[0].fclty_id, 'facility')
    //     });
    // }
    edit_timing(e) {
        this.showDta = false;
        this.showEdt = true;
        this.editInputData = {
            hndlr_nm: 'facility',
            enty_ky: this.timngsInput.enty_ky,
            // enty_ky: e.enty_ky,
            // formData: e,
            formData: this.timings,
            val: 'edit',
        };
        // // console.log(e);
        // const dialogRef = this._matDialog.open(AddTimingComponent, {
        //   data: {
        //     hndlr_nm: 'facility',
        //     enty_ky: this.fcltyLst[0].fclty_id,
        //     // enty_ky: e.enty_ky,
        //     // formData: e,
        //     formData: this.timings,
        //     val: 'edit'
        //   }
        // });

        // dialogRef.afterClosed()
        //   .subscribe((result) => {
        //     this.getTmng(this.fcltyLst[0].fclty_id, 'facility')
        //   });
    }
    // delete_timing(e){
    //   // // console.log(e);
    //   let enty_ky = e.enty_ky;
    //   let hndlr_nm = 'facility';
    //   let wk_dy_id = e.wk_dy_id
    //   this.dialogRef = this._fuseConfirmationService.open(this.configForm.value);
    //   this.dialogRef.afterClosed().subscribe((result) => {
    //       if (result == "confirmed") {
    //         this._entityService.remove_tmngs_hndlr(enty_ky, wk_dy_id, hndlr_nm).subscribe((res) => {
    //           // // console.log(res);
    //           this._entityService.openSnackBar('Day removed successfully', 'success');
    //           this.getTmng(e.enty_ky, 'facility');
    //           this._changeDetectorRef.markForCheck();
    //         });
    //       }
    //   });
    // }
    //   isChecked;
    //   onToggleChange(data,element){
    //     // console.log(data.checked,element);

    // }
    getTmng(id, hndlr_nm) {
        // console.log('-------------------------------',id,hndlr_nm);
        this._entityService.get_tmngs_hndlr(id, hndlr_nm).subscribe((res) => {
            this.timings = res['data'];
            console.log('this.timings',this.timings);
            if (this.timings.length == 0) {
                this.shwErr = true;
            }
            for (let i = 0; i < this.timings.length; i++) {
                if (this.timings[i].twtfr_hrs_in == 1) {
                    this.shw24Hrs = true;
                    this.showDta = false;
                }
            }
            this.timingColumns = [
                'sno',
                'wk_dy_nm',
                'first_session',
                'second_session',
            ];
            this._changeDetectorRef.markForCheck();
        });
    }

    timeEditOutEvnt(event) {
        console.log('backkkkkkkkkk', event);
        this.getTmng(event[0].enty_ky, 'facility');
       this.showDta = true;
        this.showEdt = false;
    }
}
